import PitchResultGroup from '../enums/grouped/PitchResultGroup.js';

// https://en.wikipedia.org/wiki/Glossary_of_baseball_(W)#whiff
// https://www.sportslingo.com/sports-glossary/w/whiff/
const classifyAsWhiff = PitchResultGroup.whiffs.results;

const classifiesAsWhiff = function(taggedPitchResultKey){
    if (typeof taggedPitchResultKey !== 'string'){
        return false;
    }

    return classifyAsWhiff.indexOf(taggedPitchResultKey) > -1;
};

export default classifiesAsWhiff;